module.exports = __webpack_public_path__ + "static/media/3-BRILLTER.db87eb7a.mp3";